<template>

  <div>
    <div class="sw-container"
         @click="toggle">
      <div class="bg" :class="value ? 'bg-selected' : 'bg-unselected'"></div>
      <div class="cycle" :class="value ? 'selected' : 'unselected'"></div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    touch: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  watch: {
    checked (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    toggle () {
      if (!this.touch) {
        return
      }
      this.value = !this.value
    }
  }
}
</script>

<style>

button {
  margin: 0;
  padding: 0;
}

.sw-container {
  position: relative;
  width: 3.09rem;
  height: 1.1rem;
  border-radius: 0.94rem;
  box-shadow: 0.09rem 0.09rem 0.09rem rgba(0, 0, 0, 0.3) inset;
}

.sw-container .cycle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 1.69rem;
  height: 1.69rem;

  border-radius: 50%;
  box-shadow: 0 0 0.19rem 0.01rem rgba(0, 0, 0, 0.3);
}

.sw-container .unselected {
  /*animation-name: cycle-unselected;*/
  /*animation-duration: 0.3s;*/
  /*animation-timing-function: ease;*/
  transform: translateY(-50%) translateX(0%);
  background-color: #F6F6F6;
}

.sw-container .selected {
  /*animation-name: cycle-selected;*/
  /*animation-duration: 0.3s;*/
  /*animation-timing-function: ease;*/
  transform: translateY(-50%) translateX(85%);
  background-color: #007AFF;
}

.sw-container .bg {
  position: absolute;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 0.94rem;
  border: 0.06rem solid rgba(0, 0, 0, 0.1);
}

.sw-container .bg-unselected {
  /*animation-name: bg-unselected;*/
  /*animation-duration: 0.2s;*/
  /*animation-timing-function: ease;*/
  background: #DBDBDB;
}

.sw-container .bg-selected {
  /*animation-name: bg-selected;*/
  /*animation-duration: 0.2s;*/
  /*animation-timing-function: ease;*/
  background: #BBDBFF;
}

@keyframes bg-selected {
  from {
    background: #fff;
  }

  to {
    background: rgb(4, 190, 2);
  }
}

@keyframes bg-unselected {
  from {
    background: rgb(4, 190, 2);
  }

  to {
    background: #fff;
  }
}

@keyframes cycle-selected {
  from {
    transform: translateY(-50%) translateX(5%);
  }

  to {
    transform: translateY(-50%) translateX(80%);
  }
}

@keyframes cycle-unselected {
  from {
    transform: translateY(-50%) translateX(80%);
  }

  to {
    transform: translateY(-50%) translateX(5%);
  }
}


</style>



// WEBPACK FOOTER //
// src/components/widgets/Switch.vue